
<matrix
    allow-horizontal
    :has-data="routeHasData"
    fetching-message="All properties (0)"
>
  <template #table-header>
    <t-column class="corner"></t-column>
    <template v-for="permittee in permissionsTablePermittees">
      <t-column is-heading :key="permittee.client_id" size="">
        <span v-tooltip="permittee.display">{{ permittee.display }}</span>
        <suffix class="c-row align-items-baseline">
          <button v-if="permittee.legacyConfigTooltip" class="tooltip-btn grey" v-tooltip="permittee.legacyConfigTooltip">
            <icon class="exclamation"></icon>
            <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
          </button>

          <kebab-actions-menu>
            <li v-if="!permittee.isFirst">
              <button @click="moveLeft(permittee)" class="dropdown-item">Move to Left</button>
            </li>
            <li v-if="!permittee.isLast">
              <button @click="moveRight(permittee)" class="dropdown-item">Move to Right</button>
            </li>
            <li>
              <button @click="$emit('remove-permittee', permittee)" class="dropdown-item">Delete</button>
            </li>
          </kebab-actions-menu>
        </suffix>
      </t-column>
    </template>
    <template >
      <t-column class="empty_cell" v-for="index in remainingColumns" is-heading :key="`empty_header_${index}`" size="">&nbsp;</t-column>
    </template>
  </template>

  <template #table-body >
    <slot name="table-rows" :remaining-columns="remainingColumns" ></slot>
  </template>
</matrix>
